import { dropFretePorConta } from 'utils/drops';

const getFormasDeEnvioFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'integra_access',
    label: 'Integração',
    type: 'select',
    options: drops?.IntegraAccess,
    multiple: true,
  },
  {
    name: 'transportadora',
    label: 'Transportadora',
    type: 'virtual-select',
    options: drops?.EntidadeTipo?.filter(
      (tipo) => tipo?.tipo === 'TRANSPORTADOR'
    ),
    multiple: true,
  },
  {
    name: 'fretepc',
    label: 'Frete por Conta',
    type: 'select',
    options: dropFretePorConta,
    multiple: true,
  },
  {
    name: 'inivalid.i',
    column: 'inivalid',
    label: 'Início da Validade Inicial',
    type: 'date',
  },
  {
    name: 'inivalid.f',
    column: 'inivalid',
    label: 'Início da Validade Final',
    type: 'date',
  },
  {
    name: 'fimvalid.i',
    column: 'fimvalid',
    label: 'Fim da Validade Inicial',
    type: 'date',
  },
  {
    name: 'fimvalid.f',
    column: 'fimvalid',
    label: 'Fim da Validade Final',
    type: 'date',
  },
];

export default getFormasDeEnvioFilterFields;
